import { render, staticRenderFns } from "./DeleteTestBuilderQuestionButton.vue?vue&type=template&id=cb4e42a6&"
import script from "./DeleteTestBuilderQuestionButton.vue?vue&type=script&lang=js&"
export * from "./DeleteTestBuilderQuestionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports